"use client";

import { XCircleIcon } from "@heroicons/react/24/solid";
import { parseFilter } from "@shared/utils";
import { Button } from "@ubud-ui/react-ui-kit";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";

export function FilterBadges({ path }: { path: string }) {
  const router = useRouter();

  const searchParams = useSearchParams();
  const parsedParams = qs.parse(searchParams.toString());

  const nonFilterKeys = ["page", "keyword"];
  const filterKeys = Object.keys(parsedParams).filter((key) => !nonFilterKeys.some((it) => it === key));
  const filterBadges = filterKeys
    .map((key) => {
      let value: any = parsedParams[key];

      if (Array.isArray(value)) {
        value = value.map((item) => {
          return {
            ...item,
            key: key,
          };
        });
      } else {
        value.key = key;
      }

      return value;
    })
    .flat();

  const handleDeleteFilter = (key: string, value: any) => {
    const paramsString = searchParams.toString();
    if (value.key) {
      delete value.key;
    }

    const params = parseFilter(key, value, qs.parse(paramsString), false);

    router.push(`${path}?${qs.stringify(params, { skipNulls: true })}`, {
      scroll: false,
    });
  };

  const handleDeleteAllFilter = () => {
    router.push(`${path}`);
  };

  if (filterKeys.length <= 0) {
    return <></>;
  }

  return (
    <div className="pb-6">
      <div className="flex flex-wrap -m-1">
        {filterBadges.map((badge) => {
          return (
            <div className="rounded-full border border-gray-200 py-1.5 px-3 m-1 flex items-center text-sm gap-1" key={badge.id}>
              <div className="flex-1">{badge.label}</div>
              <Button
                size="icon"
                className="size-5 min-w-5 text-gray-500"
                variant="ghost"
                onClick={() => handleDeleteFilter(badge.key, badge)}
              >
                <XCircleIcon className="size-5" />
              </Button>
            </div>
          );
        })}
        <Button className="font-bold text-sm self-center" size="sm" variant="link" onClick={handleDeleteAllFilter}>
          Hapus Semua
        </Button>
      </div>
    </div>
  );
}
